import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import { prefixChar } from 'utils/manipulateString';
import ResponsiveUgcProxyPicture from 'client/components/ResponsiveUgcProxyPicture';
import {
    usePrimaryPromoSelector,
    useSecondaryPromoSelector
} from 'client/game_photoContest/hooks/useReduxSelector';
import useHistoryPathPush from 'client/hooks/useHistoryPathPush';
import { setTextVariantStyle } from 'utils/variantStyle';
import Button from 'Mui/Button';
import { gameTypes } from 'config/promoGameTypes';
import ugcTypes from 'config/ugcTypes';
import { below } from 'utils/breakpoint';
function ResultContest({ resultInfo = [] }) {
    const history = useHistoryPathPush();
    const { id: contestPromoId } = usePrimaryPromoSelector(s => s.promo);
    const { type: secondaryGameType } = useSecondaryPromoSelector(s => s.promo);

    const isVideoTypeMedia = secondaryGameType === gameTypes.VIDEO_UPLOAD;

    function toPortfolio(serialNo) {
        history.push({ pathname: `/${contestPromoId}/${serialNo}` });
    }

    const filteredResultInfo = resultInfo.map(ri => ({
        ...ri,
        mediaLibrary: {
            ...ri?.mediaLibrary,
            media: ri?.mediaLibrary?.media?.filter(_ => _.type === ugcTypes.IMAGE)
        }
    }));

    const proxyConfig = {
        normal: { resizeWidth: 720 }
    };

    return (
        <div css={containerStyle}>
            {filteredResultInfo?.map(r => {
                return (
                    <div css={cardStyle} key={r.voteId}>
                        {isVideoTypeMedia ? (
                            <div css={videoWrapperStyle}>
                                <ResponsiveUgcProxyPicture
                                    src={r.mediaLibrary?.media[0]?.result ?? ''}
                                    alt={r.mediaLibrary?.title}
                                    breakPointConfigs={proxyConfig}
                                    enableLazyLoad
                                    css={mediaStyle}
                                />
                                <PlayCircleFilledWhiteIcon css={playIconStyle} />
                            </div>
                        ) : (
                            <div css={imageWrapperStyle}>
                                <ResponsiveUgcProxyPicture
                                    src={r.mediaLibrary?.media[0]?.result ?? ''}
                                    alt={r.mediaLibrary?.title}
                                    breakPointConfigs={proxyConfig}
                                    enableLazyLoad
                                    css={mediaStyle}
                                />
                            </div>
                        )}
                        <div css={ugcInfoStyle}>
                            <div>
                                <Typography variant="subtitle2">
                                    {i18n.t('label.date.value', { date: r.voteCreatedAt })}
                                </Typography>
                                <Typography variant="subtitle2">
                                    {`${i18n.t('label.id')}${prefixChar(r.voteId, '0', 7)}`}
                                </Typography>
                            </div>
                            <div>
                                <Button
                                    css={buttonStyle}
                                    variant="contained"
                                    onClick={() => toPortfolio(r.mediaLibrary.entryId)}
                                >
                                    {i18n.t('button.go_to_work_page')}
                                </Button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default ResultContest;

const containerStyle = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 0px;
    ${below('sm')} {
        padding: 0px;
    }
`;

const cardStyle = css`
    display: flex;
    gap: 8px;
    padding: 8px 0px;
    ${below('sm')} {
        &:first-of-type {
            padding-top: 0;
        }
    }
`;

const imageWrapperStyle = css`
    width: 80px;
    height: 80px;
    position: relative;
    overflow: hidden;
`;

const videoWrapperStyle = css`
    position: relative;
    height: 80px;
    width: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

const mediaStyle = css`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const playIconStyle = css`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 28px;
    height: 28px;
    color: #fff;
    pointer-events: none;
`;

const buttonStyle = css`
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-skip-ink: none;
    text-underline-position: from-font;
    background: none;
    border: none;
    padding: 0;
    margin-bottom: 2px;
    ${setTextVariantStyle('button')}
    & button {
        color: inherit;
    }
`;

const ugcInfoStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 80px;
`;
